import { Heading, HStack, Text, VStack } from '@chakra-ui/react'

import {
  getAuthUrl,
  getCollegeAdmissionsWorkshopsUrl,
  getDashboardUrl,
  getDialoguesLandingPageUrl,
  getPublicUrl,
  getSATBootcampUrl,
} from '@/client/services/url'

import OptimizedImage from '@/components/PublicImage/OptimizedImage'
import ShwLink from '@/components/ShwLink'

type Program = {
  name: string
  illustration: {
    filename: string
    originalWidth: number
    originalHeight: number
  }
  href: string
  description: string
}

const PROGRAMS: Program[] = [
  {
    name: 'SAT Bootcamps',
    illustration: {
      filename: 'sat-bootcamps.svg',
      originalWidth: 280,
      originalHeight: 200,
    },
    href: getSATBootcampUrl(),
    description: 'Free SAT tutoring designed to boost your score',
  },
  {
    name: 'Dialogues',
    illustration: {
      filename: 'dialogues.svg',
      originalWidth: 300,
      originalHeight: 256,
    },
    href: getDialoguesLandingPageUrl({ utmContent: 'navbar' }),
    description: 'One-on-one conversations with students around the globe',
  },
  {
    name: 'College Admissions Workshops',
    illustration: {
      filename: 'college-admissions-workshops.svg',
      originalWidth: 235,
      originalHeight: 300,
    },
    href: getCollegeAdmissionsWorkshopsUrl(),
    description: 'Navigate the college application process',
  },
  {
    name: 'Homework Help',
    illustration: {
      filename: 'homework-help.svg',
      originalWidth: 200,
      originalHeight: 200,
    },
    href: getAuthUrl({ mode: 'signup', returnTo: getDashboardUrl(), user: null }),
    description: 'Get unstuck on any subject, anytime',
  },
]

export default function ExplorePrograms() {
  return (
    <VStack gap="8px" p="8px" alignItems="stretch">
      {PROGRAMS.map(program => (
        <ShwLink key={program.name} href={program.href}>
          <HStack
            _hover={{ bgColor: 'bg.subtle' }}
            borderRadius="16px"
            p="16px"
            gap="16px"
            alignItems="stretch"
          >
            <OptimizedImage
              src={getPublicUrl(`programs/${program.illustration.filename}`)}
              originalWidth={128}
              originalHeight={128}
              displayWidth="64px"
              alt={program.name}
              flexShrink={0}
            />
            <VStack flexGrow={1} alignItems="flex-start" justifyContent="center">
              <Heading size="lg">{program.name}</Heading>
              <Text fontSize="sm" color="fg.subtle">
                {program.description}
              </Text>
            </VStack>
          </HStack>
        </ShwLink>
      ))}
    </VStack>
  )
}
